var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Multivariate Dependencies
import React from 'react';
import ReactDOM from 'react-dom';
// Components
import { Container } from '../../../styles/container';
// Utils
import { popupPlacement } from '../utils/popupPlacement';
import { ZIndex } from '../../../types/ZIndex';
// Hooks
import { useTargetedElementBounds } from '../hooks/useTargetedElementBounds';
/**
 * @description This is for internal use for positioning popups, popovers, or dropdown lists
 * (or anything that lies above the page)
 *
 * @example <PopupMechanism targetedElement={targetedElement} placement={placement}>
 *            <PopupContainerContent />
 *          </PopupMechanism>
 */
export var PopupMechanism = function (_a) {
    var children = _a.children, placement = _a.placement, targetedElement = _a.targetedElement, _b = _a.spaceBetweenElement, spaceBetweenElement = _b === void 0 ? 0 : _b, _c = _a.alignToTargetedElement, alignToTargetedElement = _c === void 0 ? 'center' : _c, _d = _a.shouldInheritWidth, shouldInheritWidth = _d === void 0 ? false : _d;
    var _e = useTargetedElementBounds(targetedElement), x = _e.x, y = _e.y, width = _e.width, height = _e.height;
    // get positioning css of popup
    var _f = popupPlacement[placement](x, y, width, height, spaceBetweenElement, alignToTargetedElement), left = _f.left, right = _f.right, top = _f.top, arrowCenter = _f.arrowCenter, transform = _f.transform;
    var displayStyle = x === 0 ? { display: 'none' } : { display: 'block' };
    return ReactDOM.createPortal(
    /* this div is needed to be able to pass positioning styles down
        and to account for wrapping functional components - it will always inherit its child width */
    React.createElement(Container, { zIndex: ZIndex.PORTAL, style: __assign(__assign({ 
            // @ts-ignore
            '--arrow-placement-point': arrowCenter, left: left,
            right: right,
            top: top,
            transform: transform, position: 'fixed' }, displayStyle), { justifyItems: alignToTargetedElement, width: shouldInheritWidth ? width : 'fit-content' }), height: 'fit-content' }, children), document.body);
};
//# sourceMappingURL=PopupMechanism.js.map